import type { Messages } from './en';

export const MESSAGES_DE: Messages = {
  secure_tagadapay: 'Sichere Bezahlung durch Tagada',
  checkout_title: 'Sichere Bezahlung',
  checkout_subtitle: 'Schließen Sie Ihren Einkauf sicher ab',
  express_payment: 'Express-Zahlung',
  express_payment_apple_pay: 'Mit Apple Pay bezahlen',
  express_payment_subtitle: 'Überspringen Sie das Checkout-Formular',
  informations_title: 'Informationen',
  informations_subtitle: 'Geben Sie Ihre persönlichen Informationen ein',
  shipping_address_title: 'Lieferadresse',
  shipping_address_subtitle: 'Geben Sie Ihre Lieferadresse ein',
  shipping_method_title: 'Versandmethode',
  shipping_method_subtitle: 'Wählen Sie Ihre Versandmethode unten aus',
  shipping_method_warning_title: 'Information',
  shipping_method_warning_text: 'Keine Versandmethode in Ihrem Land gefunden',
  billing_address_check: 'Rechnungsadresse unterscheidet sich von der Lieferadresse',
  billing_method_title: 'Zahlungsmethode',
  billing_method_subtitle: 'Geben Sie Ihre Rechnungsadresse ein',
  payment_title: 'Zahlung',
  payment_subtitle:
    'Wählen Sie Ihre Zahlungsmethode unten aus. Alle Transaktionen sind sicher und verschlüsselt',
  payment_credit_card: 'Kredit- oder Debitkarte',
  payment_credit_card_subtitle: 'Sichere Zahlung mit Kredit- oder Debitkarte',
  payment_paypal_subtitle: 'Sichere und schnelle Zahlung mit PayPal',
  payment_bridge_subtitle: 'Sichere und schnelle Zahlung mit Bridge',
  payment_klarna_subtitle: 'Sichere und schnelle Zahlung mit Klarna',
  payment_generic_subtitle: 'Sichere und schnelle Zahlung',
  default_payment_method_short: 'Standard',
  order_summary_discount_code: 'Rabattcode',
  order_summary_discount_discovered_callout: 'Wir haben Rabattcodes für dich gefunden',
  order_summary_discount_discovered_callout_action: 'Füge sie alle hinzu',
  order_summary_title: 'Ihre Bestellung',
  order_summary_subtotal: 'Zwischensumme',
  order_summary_shipping: 'Versand',
  order_summary_discount: 'Rabatt',
  order_summary_tax: 'Geschätzte Steuern',
  order_summary_total: 'Gesamt',
  order_summary_total_savings: 'Ersparnisse',
  button_pay: 'Jetzt bezahlen',
  button_pay_with_gateway: 'Bezahlen mit {gateway}',
  loading: 'Laden...',
  error_missing_checkout_session_id: 'Checkout-Session-ID fehlt',
  error_checkout_session_not_found: 'Checkout-Session nicht gefunden',
  error_order_already_completed: 'Bestellung bereits abgeschlossen',
  error_checkout_session_items_empty: 'Ihr Warenkorb ist leer',
  order_not_found: 'Bestellung nicht gefunden',
  thank_you_title: 'Vielen Dank für Ihre Bestellung!',
  thank_you_subtitle: 'Ihre Bestellung wurde erfolgreich aufgegeben.',
  thank_you_email_sent: 'Wir haben eine Bestätigungs-E-Mail an Ihre registrierte E-Mail-Adresse gesendet:',
  thank_you_order_details: 'Bestelldetails',
  thank_you_reference: 'Referenz',
  thank_you_date: 'Datum',
  thank_you_total: 'Gesamtsumme',
  thank_you_button_continue: 'Weiter Einkaufen',
  term_and_privacy_clicking_text: 'Durch Klicken stimme ich zu',
  term_and_condition_link_text: 'Geschäftsbedingungen',
  privacy_policy_link_text: 'Datenschutzrichtlinie',
  refund_policy_link_text: 'Rückerstattungsrichtlinie',
  shipping_policy_link_text: 'Versandrichtlinie',
  billed_as_text: 'Ihre Kreditkarte wird als {domain} belastet.',
  you_must_accept_policies: 'Sie müssen unsere',
  and: 'und',
  comma: ',',
  payment_error_title: 'Fehler',
  checkout_preview_title: 'Vorschau-Modus - Dies ist eine Entwurfsseite der Kaufabwicklung',
  order_summary_discount_code_apply_button: 'Anwenden',
  optional: 'Optional',
  field_phone: 'Telefon',
  field_phone_placeholder: 'Geben Sie Ihre Telefonnummer ein',
  field_phone_required_text: 'Telefonnummer ist erforderlich',
  field_company: 'Firma',
  field_company_placeholder: 'Geben Sie Ihren Firmennamen ein',
  checkbox_billing_address: 'Rechnungsadresse unterscheidet sich von der Lieferadresse',
  billing_address_title: 'Rechnungsadresse',
  billing_address_subtitle: 'Geben Sie Ihre Rechnungsadresse ein',
  field_first_name: 'Vorname',
  field_first_name_placeholder: 'Geben Sie Ihren Vornamen ein',
  field_first_name_error_message: 'Dieses Feld ist erforderlich',
  field_last_name: 'Nachname',
  field_last_name_placeholder: 'Geben Sie Ihren Nachnamen ein',
  field_last_name_error_message: 'Dieses Feld ist erforderlich',
  field_address: 'Adresse',
  field_address_placeholder: '123 Hauptstraße, Stadt, Land',
  field_address_error_message: 'Dieses Feld ist erforderlich',
  field_additional_address: 'Zusätzliche Adresse',
  field_additional_address_placeholder: 'Apartment, Suite, Einheit, etc.',
  field_additional_address_error_message: 'Dieses Feld ist erforderlich',
  field_city: 'Stadt',
  field_city_placeholder: 'Geben Sie Ihre Stadt ein',
  field_city_error_message: 'Dieses Feld ist erforderlich',
  field_country: 'Land',
  field_country_error_message: 'Dieses Feld ist erforderlich',
  field_state: 'Bundesland',
  field_state_placeholder: 'Geben Sie Ihr Bundesland ein',
  field_state_error_message: 'Dieses Feld ist erforderlich',
  field_postal_code: 'Postleitzahl',
  field_postal_code_placeholder: 'Geben Sie Ihre Postleitzahl ein',
  field_postal_code_error_message: 'Dieses Feld ist erforderlich',
  field_email: 'E-Mail',
  field_email_placeholder: 'Geben Sie Ihre E-Mail-Adresse ein',
  field_email_error_message: 'Dieses Feld ist erforderlich',
  credit_card_method: 'Kredit- oder Debitkarte',
  card_error_message: 'Ungültige Karteninformationen',
  card_number: 'Kartennummer',
  card_number_placeholder: 'Geben Sie Ihre Kartennummer ein',
  card_number_error_message: 'Dieses Feld ist erforderlich',
  expiry_date: 'Ablaufdatum',
  expiry_date_placeholder: 'MM/JJ',
  expiry_date_error_message: 'Dieses Feld ist erforderlich',
  expiry_date_error_message_expired: 'Ablaufdatum ist überschritten',
  cvc: 'CVC/CVV',
  cvc_placeholder: '123',
  cvc_error_message: 'CVC muss 3 oder 4 Ziffern haben',
  payment_methods_loading_error: 'Fehler beim Laden der Zahlungsmethoden',
  recommanded: 'Empfohlen',
  free: 'Kostenlos',
  customer_update_error: 'Fehler beim Aktualisieren der Informationen',
  shipping_method_empty_country: 'Wählen Sie ein Land aus, um verfügbare Versandmethoden zu sehen',
  shipping_method_update_error: 'Fehler beim Aktualisieren der Versandmethode',
  items: '{count} Artikel',
  back: 'Zurück',
  continue_to_shipping: 'Weiter zum Versand',
  continue_to_payment: 'Weiter zur Zahlung',
  contact_title: 'Kontakt',
  contact_title_subtitle: 'Geben Sie Ihre Kontaktinformationen ein',
  pay_now: 'Jetzt bezahlen',
  secure_payment_message: 'Alle Transaktionen sind sicher und verschlüsselt',
  interval_day: 'Tag',
  interval_week: 'Woche',
  interval_month: 'Monat',
  interval_year: 'Jahr',
  interval_day_plural: 'Tage',
  interval_week_plural: 'Wochen',
  interval_month_plural: 'Monate',
  interval_year_plural: 'Jahre',
  every_interval: 'Alle {count} {interval}',
  billing_every_interval: 'Abrechnung alle {count} {interval}',
  delivery_every_interval: 'Lieferung alle {count} {interval}',
  free_trial_period: '{duration} {type} kostenlose Testphase',
  first_payment_free: 'Erste Zahlung kostenlos',
  subscription_trial_notice:
    'Ihr Abonnement enthält eine kostenlose Testphase. Ihnen wird nichts berechnet, bis die Testphase endet.',
  recurring_total_with_interval: 'Wiederkehrender Gesamtbetrag (alle {count} {interval})',
  trial_ends_on: 'Testphase endet am {date}',
  billing_timing: 'Abrechnung: {timing}',
  billing_cycle_anchor: 'Abrechnungszyklus-Anker',
  field_marketing_label: 'Ich stimme dem Erhalt von Marketing-E-Mails zu',
  terms_acceptance_text: 'Durch Klicken stimme ich zu',
  cart_title: 'Warenkorb',
  payment_failed_message: 'Zahlung fehlgeschlagen',
  email: {
    abandoned_checkout: {
      preview: 'Schließen Sie Ihren Einkauf ab',
      default_body:
        'Wir haben bemerkt, dass Sie einige Artikel in Ihrem Warenkorb gelassen haben. Möchten Sie Ihren Einkauf abschließen?',
      cart_title: 'Ihr Warenkorb',
      quantity: 'Menge',
      recurring: 'Wiederkehrend {interval}lich',
      trial_period: '({duration} {type} Testphase)',
      subtotal: 'Zwischensumme',
      discounts: 'Rabatte',
      total: 'Gesamt',
      cta_button: 'Einkauf abschließen',
      footer_text: 'Bei Fragen antworten Sie einfach auf diese E-Mail - wir helfen Ihnen gerne weiter.',
    },
    order_paid: {
      // Add order paid email translations here when needed
    },
  },
  image_upload: {
    errors: {
      unauthorized: 'Nicht autorisiert',
      unsupported_content_type: 'Nicht unterstützter Inhaltstyp',
      single_file_required: 'Eine einzelne Datei ist erforderlich',
      file_too_big: 'Die Datei ist zu groß',
      non_image_file: 'Kann keine Nicht-Bilddateien verarbeiten',
    },
  },
  promotion_code_invalid: 'Dieser Rabattcode ist nicht gültig',
  applying: 'Anwenden...',
  processing_payment: 'Zahlung wird verarbeitet...',
  select_country: 'Land auswählen',
  select_state: 'Bundesland auswählen',
  order_details: 'Bestelldetails',
  order_number: 'Bestellnummer',
  order_date: 'Bestelldatum',
  email_confirmation: 'Bestellbestätigung',
  confirmation_sent_to: 'Bestellbestätigung an',
  shipping_address: 'Lieferadresse',
  billing_address: 'Rechnungsadresse',
  payment_successful: 'Zahlung erfolgreich',
  recurring_total: 'Wiederkehrender Gesamtbetrag',
  payment_is_blacklisted: 'Die Zahlung ist gesperrt',
  checkout_has_errors_title: 'Validierung',
  checkout_has_errors: 'Die unten stehenden Informationen sind ungültig oder fehlen',
  checkout_email_error: 'E-Mail-Adresse',
  checkout_shipping_address_error: 'Lieferadresse',
  checkout_billing_address_error: 'Rechnungsadresse',
  checkout_shipping_rate_error: 'Versandrate',
  checkout_pickup_address_error: 'Abholadresse',
  checkout_payment_info_error: 'informazioni di pagamento',
  checkout_phone_error: 'Telefonnummer',
  checkout_terms_error: 'Sie haben die Nutzungsbedingungen nicht akzeptiert',
  payment: {
    genericError: 'Payment failed. Please try again with a different payment method.',
  },
  error: {
    unexpected: 'An unexpected error occurred. Please try again.',
  },
  checkout_completed_title: 'Zahlung Abgeschlossen',
  checkout_already_completed: 'Diese Bestellung wurde bereits bezahlt',
  payment_completed: 'Zahlung Abgeschlossen',
  apply_vip_offers: 'Jetzt als VIP bezahlen',
  confirm_vip_payment: 'Bezahlen',
  cancel_vip_offers: 'VIP-Angebote abbrechen',
  vip_total_difference: 'Differenz: {difference}',
  total_as_vip: 'VIP',
  vip_savings: 'VIP-Ersparnis',
  vip_savings_available: 'VIP-Ersparnis verfügbar',
  vip_savings_confirmed: 'VIP-Ersparnis angewendet',
  vip_savings_message: 'Wählen Sie VIP-Zahlung, um diese Ersparnisse freizuschalten!',
  vip_savings_applied_message: 'Sie sparen {amount} mit VIP-Vorteilen!',
  vip_offer_savings_confirmed: 'VIP-Angebot angewendet',
  vip_offer_savings_available: 'VIP-Angebot verfügbar',
  vip_offer_savings_message: 'Wenden Sie das VIP-Angebot an, um bei Ihrer Bestellung zu sparen',
  vip_offer_savings_applied_message: 'Sie sparen {amount} mit dem VIP-Angebot',
  apply_vip_offer: 'Als VIP bezahlen',
  cancel_vip_offer: 'VIP-Angebot abbrechen',
  you_save: 'Sie sparen {amount}',
  you_save_on_order: 'Sie sparen {amount} bei Ihrer Bestellung',
  you_save_available: 'Sparen Sie {amount} bei Ihrer Bestellung mit dem exklusiven VIP-Angebot',
  free_trial_then_price: '{duration} {type} kostenlose Testphase, dann {price}/{interval}',
  free_trial_period_short: '{duration} {type} kostenlos',
  click_to_apply: 'Klicken Sie hier, um anzuwenden',
  please_select_shipping_country: 'Bitte wählen Sie ein Land aus, um verfügbare Versandmethoden zu sehen',
  invalid_phone_number: 'Ungültige Telefonnummer',
  click_errors_to_navigate: 'Klicken Sie auf die Fehler, um zu den Abschnitten zu navigieren',
  pickup_point: 'Abholpunkt',
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  sunday: 'Sonntag',
  promotion_code_usage_limit_reached: 'Dieser Rabattcode hat sein Nutzungslimit erreicht',
  promotion_code_first_time_only: 'Dieser Rabattcode ist nur für Erstkunden gültig',
  promotion_code_invalid_email: 'Dieser Rabattcode ist für Ihre E-Mail-Adresse nicht gültig',
  promotion_code_cannot_apply: 'Dieser Rabattcode kann nicht angewendet werden',
  promotion_code_already_applied: 'Dieser Rabatt ist bereits angewendet',
  promotion_code_expired: 'Dieser Rabattcode ist abgelaufen',
  promotion_code_cannot_remove_auto: 'Automatisch angewendete Rabatte können nicht entfernt werden',
  promotion_code_remove_failed: 'Entfernen des Rabattcodes fehlgeschlagen',
  remove: 'Entfernen',
  pickup_select_point: 'Abholpunkt auswählen',
  pickup_select_point_description: 'Wählen Sie einen Abholpunkt in Ihrer Nähe',
  pickup_click_to_select: 'Zum Auswählen klicken',
  pickup_change_point: 'Abholpunkt ändern',
  pickup_change: 'Ändern',
  pickup_opening_hours: 'Öffnungszeiten',
  pickup_closed: 'Geschlossen',
  pickup_point_error: 'Beim Auswählen des Abholpunkts ist ein Fehler aufgetreten',
  pickup_view_list: 'Listenansicht',
  pickup_view_map: 'Kartenansicht',
  pickup_open_map: 'Karte öffnen',
  pickup_open_map_description: 'Klicken Sie hier, um die interaktive Karte zu öffnen',
  pickup_no_points_found: 'Keine Abholpunkte in diesem Bereich gefunden',
  cancel: 'Abbrechen',
  order_confirmed: 'Bestellung bestätigt',
  view_order_details: 'Bestelldetails anzeigen',
  back_to_portal: 'Zurück zum Portal',
  customer_details: 'Kundendetails',
  customer_email: 'E-Mail',
  customer_id_label: 'Kunden-ID',
  customer_first_name: 'Vorname',
  customer_last_name: 'Nachname',
  customer_locale: 'Sprache',
  marketing_consent: 'Marketing-Einstellungen',
  marketing_accepted: 'Für Marketing angemeldet',
  marketing_declined: 'Nicht für Marketing angemeldet',
  customer_created_at: 'Kunde seit',
  order_status_label: 'Bestellstatus',
  order_status_paid: 'Bezahlt',
  order_status_pending: 'Ausstehend',
  order_status_cancelled: 'Storniert',
  post_purchase: {
    title: 'Wir haben diese Angebote speziell für Sie gefunden',
    view_deal: 'Angebot ansehen',
    get_deal_now: 'Jetzt zuschlagen',
    bundle_content: '{count, plural, =0 {kein Artikel} =1 {# Artikel} other {# Artikel}}',
    adding_to_cart: 'Wird verarbeitet...',
    vip_only: 'Nur für VIP',
    products: '{count, plural, =0 {Keine Produkte} =1 {# Produkt} other {# Produkte}}',
    skip: 'überspringen',
    skip_addition: 'zur Zusammenfassung',
    exclusive_offer: 'Exklusives Einmalangebot',
    offer_expires_in: 'Angebot läuft ab in',
    minutes: 'Min',
    save: 'Sparen Sie',
    secure_checkout: 'Sicherer Checkout',
    safe_payment: 'Sichere Zahlung',
    limited_time_offer: 'Zeitlich begrenztes Angebot',
    previous: 'Zurück',
    no_thanks: 'Nein danke',
    offer_count: 'Angebot {current} von {total}',
    special_offer_title: 'Spezielles Angebot für Sie',
  },
  billing_plan: 'Abrechnungsplan',
  customer: 'Kunde',
  current_period: 'Aktueller Zeitraum',
  trial_period: 'Testzeitraum',
  cancellation_notice: 'Kündigungsmitteilung',
  subscription_cancellation_end_period: 'Dieses Abonnement wird am Ende des aktuellen Zeitraums gekündigt.',
  created: 'Erstellt',
  product_id: 'Produkt-ID',
  resuming: 'Wird fortgesetzt...',
  resume_subscription: 'Abonnement fortsetzen',
  canceling: 'Wird gekündigt...',
  cancel_subscription: 'Abonnement kündigen',
  my_subscriptions: 'Meine Abonnements',
  subscriptions: 'Abonnements',
  no_active_subscriptions: 'Sie haben keine aktiven Abonnements.',
  active: 'Aktiv',
  trial: 'Testphase',
  loading_subscriptions: 'Ihre Abonnements werden geladen...',
  qty: 'Menge',
  id: 'ID',
  by_canceling: 'Durch die Kündigung werden Sie:',
  lose_club_advantages: 'Alle Vorteile der Club-Mitgliedschaft verlieren',
  lose_accumulated_credits: 'Alle bisher gesammelten Credits verlieren',
  lose_promotion_code: 'Ihren persönlichen Rabattcode mit exklusiven Rabatten im Shop verlieren',
  confirm_proceed: 'Sind Sie sicher, dass Sie fortfahren möchten?',
  cancel_club_membership:
    'Dies wird Ihre Club-Mitgliedschaft am Ende des aktuellen Abrechnungszeitraums kündigen.',
  cancel_subscription_notice: 'Dies wird Ihr Abonnement am Ende des aktuellen Abrechnungszeitraums kündigen.',
  keep_subscription: 'Abonnement behalten',
  yes_lose_benefits: 'Ja, ich möchte alle Vorteile der Subclub-Mitgliedschaft verlieren',
  yes_cancel: 'Ja, kündigen',
  cancel_subscription_title: 'Abonnement kündigen',
  membership: 'Mitgliedschaft',
  related_orders: 'Verbundene Bestellungen',
  related_orders_description: 'Bestellungen aus Angeboten nach dem Kauf',
  order_status: 'Status',
  order_total: 'Gesamt',
  order_items: 'Artikel',
  order_type: 'Typ',
  view_order: 'Bestellung ansehen',
  order_item_count: '{count, plural, =1 {# Artikel} other {# Artikel}}',
  related_order_from: 'Aus {offerType}-Angebot',
  no_related_orders: 'Keine verbundenen Bestellungen',
  total_with_related_orders: 'Gesamt mit verbundenen Bestellungen',
  discount_applied: 'Rabatt angewendet',
  paid: 'Bezahlt',
  pending: 'Ausstehend',
  processing: 'In Bearbeitung',
  cancelled: 'Storniert',
  refunded: 'Erstattet',
  vip_post_purchase: {
    title: 'Sie haben noch Zeit!',
    subtitle: 'Abonnieren Sie unsere Clubmitgliedschaft und gewinnen Sie groß!',
    action_cancel: 'Nein, danke',
    action_subscribe: 'Abonnieren',
    savings: 'Sie sparen {amount}',
    offer_title: 'Exklusives Angebot, das Sie nicht verpassen sollten',
    offer_description: '',
  },
  shopify: {
    notes: {
      sendcloud_pickup: {
        id: 'Abholpunkt-ID',
        name: 'Abholpunkt-Name',
        street: 'Abholpunkt-Adresse',
        type: 'Abholpunkt-Typ',
        city: 'Abholpunkt-Stadt',
        postal_code: 'Abholpunkt-Postleitzahl',
        country: 'Abholpunkt-Land',
        carrier: 'Abholpunkt-Transporteur',
        code: 'Abholpunkt-Code',
        latitude: 'Abholpunkt-Breitengrad',
        longitude: 'Abholpunkt-Längengrad',
      },
    },
  },
};
